<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data.value" placeholder="请选择"
             @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in ProductSoftware" :key="index"></el-option>
  </el-select>
</template>

<script>
    
    import { getProductModle,getProductSoftware} from "@/services/product";
    

    export default {
        name: 'Software',
        props: {
            value: {},
         
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            }
        },

        data() {
            return {data: {}, ProductSoftware: []}
        },
        watch: {
            value:{
                immediate:true,
                handler(value){
                    if (value) {
                            this.data = value;
                        } else {
                            this.data = {};
                        }

                }
            },
           
        },
        mounted() {
            this.loadData();
        },
        methods: {
           
            handleChange(value) {
                
                let find = this.ProductSoftware.find((item, i) => {
                    return item.value == value
                })
                if (!find) {
                    find = {};
                }
               
                if (find==undefined) {
                    find = "";
                }
                this.$emit("input", {...find});
                this.$emit("change", {...find});
                this.data = {...find};
            },
            async loadData() {
               

              
                const res2 =await  getProductSoftware({page:1,size:999})
                if(res2&&res2.code==0){
                     this.ProductSoftware =res2.data.list.map((item, i) => {
                        return {name: item.version, value: item.version}
                    })
                 
                }
              
               
              
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/software.vue